export default {
  mounted: function () {
    $(function () {
      $('.btn-mov').click(function () {
        $('#overlay').fadeIn();
        $(this)
          .children('.mov_wrapper')
          .fadeIn();
      });
      $('.btn-detail').click(function () {
        $('#overlay').fadeIn();
        $(this)
          .children('.over_wrapper')
          .fadeIn();
      });
      $('#overlay').click(function () {
        $('#overlay').fadeOut();
        $('.mov_wrapper').fadeOut();
        $('.over_wrapper').fadeOut();
      });
      $('#over_close').click(function () {
        $('#overlay').fadeOut();
        $('.mov_wrapper').fadeOut();
        $('.over_wrapper').fadeOut();
      });
    });
    var listDatas = [
      // Section1
      {
        name: 'pdf1_1',
        message: "<a href='pdf/1/1_4_1-3.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section2
      {
        name: 'web2_1',
        message: "<a href='https://www.ucc.co.jp/largo/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web2_2',
        message: "<a href='https://cafe-owners.jp/coffee_menu/type/ibc.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf2_1',
        message: "<a href='pdf/2/2_1_6.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf2_2',
        message: "<a href='pdf/2/2_1_7.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf2_3',
        message: "<a href='pdf/2/Largo.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf2_4',
        message: "<a href='pdf/2/2_1_8.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section3
      {
        name: 'web3_1',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=classeusb1g_1' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web3_2',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=2650' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web3_3',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=classeusb1g' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web3_4',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=3444' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web3_5',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=3448' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf3_1',
        message: "<a href='pdf/3/2_1_9.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section4
      {
        name: 'web4_1',
        message: "<a href='https://www.hoshizaki.co.jp/p/dcm/hdi-30a.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_2',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=ecambh' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_3',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=broodv2px-1tap' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_4',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=bonmac_bm-lcd' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_5',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=post_13' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_6',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/news/item.php?id=lacup' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_7',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=bonmac_bmfaf2' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_8',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/news/item.php?id=lacup' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_9',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=lacup' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web4_10',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/products/item.php?id=post_16' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      // Section5
      {
        name: 'web5_1',
        message: "<a href='https://cafe-owners.jp/coffee_menu/type/ibc.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web5_2',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=broodv2px-1tap' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf5_1',
        message: "<a href='pdf/5/2_3_7.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf5_2',
        message: "<a href='pdf/5/2_3_9.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf5_3',
        message: "<a href='pdf/5/2_3_6.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf5_4',
        message: "<a href='pdf/5/2_3_5.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf5_5',
        message: "<a href='pdf/5/2_3_10.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section6
      {
        name: 'web6_1',
        message: "<a href='https://cafe-owners.jp/coffee_menu/type/fob.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf6_1',
        message: "<a href='pdf/6/2_4_7.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_2',
        message: "<a href='pdf/6/2_4_8.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_3',
        message: "<a href='pdf/6/2_4_9.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_4',
        message: "<a href='pdf/6/2_4_10.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_5',
        message: "<a href='pdf/6/2_4_4_フルーティ.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_6',
        message: "<a href='pdf/6/2_4_4_フルボディ.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_7',
        message: "<a href='pdf/6/2_4_4_関東エリア.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_8',
        message: "<a href='pdf/6/2_4_4_スプリング.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_9',
        message: "<a href='pdf/6/2_4_11.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_10',
        message: "<a href='pdf/6/2_4_12.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf6_11',
        message: "<a href='pdf/6/2_4_6.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section7
      {
        name: 'web7_1',
        message: "<a href='https://www.ucc.co.jp/company/csr/index.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web7_2',
        message: "<a href='https://cafe-owners.jp/coffee_menu/type/vest.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf7_1',
        message: "<a href='pdf/7/2_5_2.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf7_2',
        message: "<a href='pdf/7/2_5_3.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf7_3',
        message: "<a href='pdf/7/2_5_5.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section8
      {
        name: 'web8_1',
        message: "<a href='https://www.lucky-coffee-machine.co.jp/bonmac/sad1-coinmech.php' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web8_2',
        message: "<a href='https://www.ucc.co.jp/company/news/2019/rel190110a.html' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      // Section9
      {
        name: 'web9_1',
        message: "<a href='https://www.qbit-robotics.jp/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      // Section10
      {
        name: 'web10_1',
        message: "<a href='http://www.lucky-coffee-machine.co.jp/products/item.php?id=broodv2px-1tap' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf10_1',
        message: "<a href='pdf/10/2_7_3_01.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf10_2',
        message: "<a href='pdf/10/2_7_3_02.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf10_3',
        message: "<a href='pdf/10/2_7_3_03.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section11
      {
        name: 'web11_1',
        message: "<a href='https://foodsfridge.jp/ja/list?category_code=drink' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf11_1',
        message: "<a href='pdf/11/2_8_02.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf11_2',
        message: "<a href='pdf/11/2_8_04.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section12
      {
        name: 'web12_1',
        message: "<a href='https://www.ucc.co.jp/promesso/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf12_1',
        message: "<a href='pdf/12/2_9_11_2.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section13
      {
        name: 'web13_1',
        message: "<a href='https://www.ucc.co.jp/cafitesse/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf13_1',
        message: "<a href='pdf/13/2_9_13.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf13_2',
        message: "<a href='pdf/13/2_9_11_1.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf13_3',
        message: "<a href='pdf/13/2_9_11_2.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section14
      {
        name: 'web14_1',
        message: "<a href='http://drip-pod.jp/drippod/machine/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web14_2',
        message: "<a href='http://drip-pod.jp/public/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf14_1',
        message: "<a href='pdf/14/2_10_9.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf14_2',
        message: "<a href='pdf/14/2_10_02.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section15
      {
        name: 'web15_1',
        message: "<a href='https://www.uccfoods.co.jp/catalog/event2019/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf15_1',
        message: "<a href='pdf/15/3_3_3.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf15_2',
        message: "<a href='pdf/15/3_3_4.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf15_3',
        message: "<a href='pdf/15/3_3_5.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf15_4',
        message: "<a href='pdf/15/3_3_6.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf15_5',
        message: "<a href='pdf/15/3_3_13.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section16
      {
        name: 'web16_1',
        message: "<a href='https://foodsfridge.jp/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf16_1',
        message: "<a href='pdf/16/3_1_5.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf16_2',
        message: "<a href='pdf/16/3_1_6.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf16_3',
        message: "<a href='pdf/16/3_1_7.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf16_4',
        message: "<a href='pdf/16/3_1_8.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section17
      {
        name: 'web17_1',
        message: "<a href='https://foodsfridge.jp/recipe' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'web17_2',
        message: "<a href='https://www.uccfoods.co.jp/catalog/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf17_1',
        message: "<a href='pdf/17/3_2_11.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_2',
        message: "<a href='pdf/17/3_2_7.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_3',
        message: "<a href='pdf/17/3_2_12.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_4',
        message: "<a href='pdf/17/3_2_8.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_5',
        message: "<a href='pdf/17/3_2_13.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_6',
        message: "<a href='pdf/17/3_2_9.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_7',
        message: "<a href='pdf/17/3_2_14.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf17_8',
        message: "<a href='pdf/17/3_2_10.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section18
      {
        name: 'web18_1',
        message: "<a href='https://www.uccfoods.co.jp/catalog/event2019_item/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf18_1',
        message: "<a href='pdf/18/3_4_02.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      {
        name: 'pdf18_2',
        message: "<a href='pdf/18/3_5_02.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      },
      // Section19
      {
        name: 'web19_1',
        message: "<a href='https://foodsfridge.jp/' target='_blank'><p class='target'>Webページへ移動</p></a>"
      },
      {
        name: 'pdf19_1',
        message: "<a href='pdf/19/3_8_5.pdf' target='_blank'><p class='target'>資料Download / 続きを読む</p></a>"
      }
    ];

    var $lightBoxBg = $('#lightBoxBg');
    var $lightBox = $('#lightBox');

    $('.block')
      .children('ul')
      .children('li')
      .each(function () {
        $(this)
          .children('a')
          .click(function () {
            var myName = $(this)
              .parent()
              .find('.name')
              .html();
            var imageSrc = $(this)
              .parent()
              .find('.photo')
              .children('img')
              .attr('src');
            attachMenber(myName, imageSrc);
          });
      });

    var $closeBtn = $('#closeBtn');
    $closeBtn.click(function () {
      removeLightBox();
    });

    function removeLightBox() {
      $lightBoxBg.fadeOut(300);
      $lightBox.fadeOut(300);
    }

    $lightBoxBg.click(function () {
      removeLightBox();
    });

    var $detailImages = $('#detailImages');
    var $detailMessage = $('#detailMessage');

    function attachMenber(myName, imageSrc) {
      for (var i = 0; i < listDatas.length; i++) {
        if (listDatas[i].name == myName) {
          $detailImages.attr('src', imageSrc);
          $detailMessage.html(listDatas[i].message);
        }
      }
      $lightBoxBg.fadeIn(300);
      $lightBox.fadeIn(300);
    }
  }
};